import { Button, Card, CardContent, Divider, Grid, IconButton, Skeleton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import * as React from 'react';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import { get } from '../../libraries/network';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getDateFormatByLocation } from '../../libraries/format';
import { ProgressDialog } from '../elements/progressDialog';
import AlertDialog from '../elements/alertDialog';



export function ReportBookingStopped()
{

    const [range, setRange] = React.useState( new Date() )
    const [busy, setBusy] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [error, setError] = React.useState('');
    const [progress, setProgress] = React.useState(0);


    const onDownloadClick  = () =>
    {
        var rows = [
            ["first name", "last name", "email address", 'mobile', 'Last event booked'],
        ].concat(data.map( r => [`${r.firstname}, ${r.lastname}, ${r.email}, ${r.mobile}, ${r.event_name} ${r.event_date}`]));
 

        
        let csvContent = "data:text/csv;charset=utf-8," + rows.map(e => Object.values(e).join(",")).join("\n");        
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "event-bookings-stopped-" + (new Date()).toDateString()+ ".csv");
        document.body.appendChild(link); // Required for FF

        link.click();
    }


    const onSubmit = ( e ) => {
        e.preventDefault();
        setBusy(true);

        async function load() {
            try{
                var d = range.getTime() / 1000
                setProgress(10);
                const data = await get( `/reportsrestapi/not-booked-after/${d}`);
                setProgress(100);        
                setData( data );
                setTimeout(() => {
                    setProgress(0);
                    setBusy(false);
                }, 500)
                
            }
            catch(e)
            {
                console.error(e);
                if(window?.static_override)
                {

                    console.log( window?.static_reports );
                    setProgress(100);
                    setTimeout(() => {
                        setBusy(false);
                        setProgress(0);
                        setData(window?.static_reports.report_booking_stopped);
                    }, 2000)
                }  
                else
                {
                    setBusy(false);
                    setProgress(0);
                    setError('Failed to load report')
                } 
                
                // to do - present error 

            }
        }
        load();

    }


    return (
        <div className="rvNS">

            <form onSubmit={onSubmit}>
                <Box sx={{p: 0}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="div" sx={{pt: 1, pb:1}}>
                                        Configure the report <span className='small'>complete the following form and click fetch report</span>
                                    </Typography>
                                    <Divider/>
                                    <Box sx={{pt: 3, pb: 3}}>

                                       <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Typography variant='h7' gutterBottom component="div">Step 1: Select date cut-off</Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>

                                            <MobileDatePicker
                                                label="Cut off date"
                                                inputFormat={getDateFormatByLocation()}
                                                value={range}
                                                onChange={e => setRange(new Date(e))}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                            </LocalizationProvider>
                                            </Grid>
                     
                
                                            <Grid item xs={12}>
                                                <Button type="submit" fullWidth variant="contained">Fetch report</Button>
                                            </Grid>                                              
                                       </Grid>
                                         
                                    </Box>
                                </CardContent>
                            </Card>  

                        </Grid> 
                        <Grid item xs={12} md={12}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Grid container>
                                        <Grid item >
                                            <Typography gutterBottom variant="h5" component="div" sx={{pt: 1, pb:1}}>
                                                Report
                                            </Typography>                                            
                                        </Grid>
                                        <Grid item >
                                            <IconButton aria-label="delete" size="large" onClick={onDownloadClick}>
                                                <FileDownloadIcon fontSize="inherit" />
                                            </IconButton>
                                        </Grid>                                        
                                    </Grid>


                                    <Divider/>
                    
                                    { 
                                        busy && 
                                        <Box sx={{pt: 3, pb: 3}}>
                                            <Stack>
                                                <Skeleton height={40} />
                                                <Skeleton  height={40} />
                                                <Skeleton  height={40} />
                                                <Skeleton  height={40} />
                                            </Stack>
                                        </Box>                                        

                                    }
                                    { 
                                        !busy && !data?.length &&
                                        <Box sx={{pt: 3, pb: 3}}>
                                            <Grid container direction="row" justifyContent="center" alignItems="center">
                                                <Grid item><NotInterestedIcon className="icon opaque"/></Grid>
                                            </Grid>
                                        </Box>
                                    }
                                    { 
                                        !busy && !!data?.length &&
                                        <Box sx={{pt: 3, pb: 3}}>
                                            <Grid container direction="row" justifyContent="center" alignItems="center">
                                                <TableContainer>
                                                    <Table>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>
                                                                    ID
                                                                </TableCell>
                                                                <TableCell>
                                                                    Name
                                                                </TableCell>
                                                                <TableCell>
                                                                    Email
                                                                </TableCell>
                                                                <TableCell>
                                                                    Contact
                                                                </TableCell>
                                                                <TableCell>
                                                                    Last Event booked
                                                                </TableCell>

                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {
                                                                data?.map( d => (
                                                                    <TableRow key={`report-${d.id}`}>
                                                                        <TableCell>
                                                                            {d.id}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {`${d.firstname} ${d.lastname}`}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {d.email}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {d.mobile}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {`${d?.event_name} ${(new Date(d?.event_date)).toLocaleDateString()}`}
                                                                        </TableCell>
                                                                        
                                                                    </TableRow>
                                                                ))   
                                                            }

                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>

                                            </Grid>
                                        </Box>
                                    }
                                          
                                </CardContent>
                            </Card>  

                        </Grid>


   
                    </Grid>
                </Box>
            </form>                

            {
                !!error &&
                <AlertDialog title="Problem detected" description={error} handleClose={()=>{setError(false)}} />             
            }
            {
                progress > 0 &&
                <ProgressDialog title="Please standby. Fetching data..." text={''} progress={progress} />
            }
        </div>
    )
}